module.exports = __webpack_public_path__ + "img/incognito.baa8b32e.png";